exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".i-affix[data-v-3f251002]{position:fixed;z-index:99999}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-3f251002&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/affix/src/affix.vue
// module id = 471
// module chunks = 0